module.exports = __webpack_public_path__ + "img/1459133873.318b9d74.jpg";